<docs>
  Use social media to share viewer on it.
</docs>

<template>
  <i-repeat
    class="share-list"
    :items="shareList"
  >
    <template #default="{ item }">
      <a
        role="button"
        class="share-list-a"
        :href="item.url"
        :target="item.target"
        :style="item.style"
        @click="item.method"
      >
        <icon
          class="share-list-icon"
          :image="item.image"
          :style="item.iconStyle"
          :has-lazyload="true"
        />
        <span class="share-list-text">
          {{ item.text }}
        </span>
      </a>
    </template>
  </i-repeat>
</template>

<script>
import { mapGetters } from 'vuex'
import { isMobile } from '~js/utils'
import gaEvents from '~js/ga-events'
import server from '~js/server'
import Icon from '../../Icon/index.vue'
import IRepeat from '../../IRepeat.vue'
import HandleData from '../../../mixins/HandleData.vue'

export default {
  name: 'ShareList',
  components: {
    Icon,
    IRepeat
  },

  mixins: [
    HandleData
  ],

  computed: {
    ...mapGetters([
      'currentBuilding',
      'shareUrl'
    ]),

    shareList () {
      return [
        {
          name: 'facebook',
          image: require('./img/share/facebook.png'),
          target: '_blank',
          url: `https://www.facebook.com/sharer/sharer.php?u=${this.shareUrl.facebook}`,
          text: 'Facebook',
          style: {
            backgroundColor: '#1877F2'
          },
          iconStyle: {
            width: '24px',
            height: '24px',
            top: 'calc(50% - 12px)'
          },
          method: () => {
            gaEvents.sendEvent('Building', 'ClickShareToFacebook', this.currentBuilding.objectId)
          }
        },
        {
          name: 'twitter',
          image: require('./img/share/twitter.svg'),
          target: '_blank',
          url: `https://twitter.com/intent/tweet?url=${this.shareUrl.twitter}`,
          text: 'Twitter',
          style: {
            backgroundColor: '#1D9BF0'
          },
          iconStyle: {
            width: '24px',
            height: '24px',
            top: 'calc(50% - 12px)'
          },
          method: () => {
            gaEvents.sendEvent('Building', 'ClickShareToTwitter', this.currentBuilding.objectId)
          }
        },
        {
          name: 'messenger',
          hidden: !isMobile(),
          image: require('./img/share/messenger.svg'),
          target: '_self',
          url: `fb-messenger://share?link=${encodeURIComponent(this.shareUrl.messenger)}&app_id=${encodeURIComponent(server.facebookAppId)}`,
          text: 'Messenger',
          style: {
            backgroundColor: '#000000'
          },
          iconStyle: {
            width: '24px',
            height: '24px',
            top: 'calc(50% - 12px)'
          },
          method: () => {
            gaEvents.sendEvent('Building', 'ClickShareToMessenger', this.currentBuilding.objectId)
          }
        },
        {
          name: 'line',
          hidden: !isMobile(),
          image: require('./img/share/line.png'),
          target: '_blank',
          url: `http://line.me/R/msg/text/?${document.title} ${this.shareUrl.line}`,
          text: 'Line',
          style: {
            backgroundColor: '#06C755'
          },
          iconStyle: {
            width: '24px',
            height: '24px',
            top: 'calc(50% - 12px)'
          },
          method: () => {
            gaEvents.sendEvent('Building', 'ClickShareToLine', this.currentBuilding.objectId)
          }
        },
        {
          name: 'whatsapp',
          hidden: !isMobile(),
          image: require('./img/share/whatsapp.svg'),
          target: '_blank',
          url: `https://wa.me/?text=${encodeURIComponent(this.shareUrl.whatsapp)}`,
          text: 'WhatsApp',
          style: {
            backgroundColor: '#25D366'
          },
          iconStyle: {
            width: '24px',
            height: '24px',
            top: 'calc(50% - 12px)'
          },
          method: () => {
            gaEvents.sendEvent('Building', 'ClickShareToWhatsApp', this.currentBuilding.objectId)
          }
        }
      ]
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.share-list {
  width: 240px

  >>> .i-repeat-li {
    margin-top: 20px

    &:last-child {
      margin-bottom: 20px
    }
  }
}

.share-list-a {
  position: relative
  display: flex
  align-items: center
  justify-content: flex-start
  cursor: pointer
  width: 100%
  height: 40px
  border-radius: 5px
}

.share-list-icon {
  position: absolute
  background-size: 100% 100%
  margin-left: $share-list-share-list-icon-margin
}

.share-list-text {
  @extend .text-with-gray-bg
  margin-left: $share-list-share-list-text-margin
  font-size: 20px
  font-weight: 400
  line-height: 24px
}

@media (min-width: $response) {
  .share-list {
    width: 260px
  }
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'

.theme-rtl.theme-rtl-overlap {
  .share-list-icon {
    margin-left: 0
    margin-right: $share-list-share-list-icon-margin
  }

  .share-list-text {
    margin-left: 0
    margin-right: $share-list-share-list-text-margin
  }
}
</style>
